import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useGetLoggedUser } from "../../shared/hooks/useUser";

const LoginProtected = ({ children }) => {
    const { data: loggedUser, status } = useGetLoggedUser(true);

    const [loggedIn, setLoggedIn] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        if (loggedUser && loggedUser.user_type) {
            if (loggedUser.user_type !== "Website User") {
                // navigate("/tables")
                setLoggedIn(true);
            } else {
                setLoggedIn(false);
            }
        }
    }, [loggedUser]);

    if (loggedIn) {
        return <Navigate to={"/tables"} replace />;
    }
    return children;
};

export default LoginProtected;
